<template>
    <div>
        <div class="btn btn-xs btn-default" @click="showDialog = true">
            <i class="fa fa-search"></i>
            View
        </div>

        <AddToOrder
            v-if="value.inventory_item_id"
            :vendor-id="value.vendor_id"
            :product-id="value.product_id"
            :inventory-item-id="value.inventory_item_id"
            :order-items="value.order_items"
            />

        <AddToWatchListButton
            v-if="value.amazon_product_id"
            :amazon-product-id="value.amazon_product_id"
            />

        <AddProductBanButton
            v-if="$can('manage-product-bans')"
            :product-id="value.product_id"
            />

        <VendorInventoryItemDialog v-if="showDialog" :id="value.id" @hide="showDialog = false" />
    </div>
</template>

<script>
export default {
    components: {
        VendorInventoryItemDialog: require('@/pages/vendors/VendorInventoryItemDialog.vue').default,
        AddProductBanButton: require('@/components/products/AddProductBanButton.vue').default,
    },
    props: ['value'],
    data() {
        return {
            showDialog: false,
        };
    },
};
</script>
